<template>
    <v-alert
        v-if="!isLoggedIn"
        v-bind="attrs"
        density="compact"
        variant="flat"
        border="start"
    >
        <div class="d-flex align-center">
            <span>
                <slot />
            </span>
            <v-spacer></v-spacer>
            <v-btn
                @click="onSignIn()"
                color="secondary"
                variant="tonal"
            >
                Sign In
            </v-btn>
        </div>
    </v-alert>
</template>

<script lang="ts" setup>
    import { useCustomAuth } from '~/composables';
    
    const route = useRoute();
    const { isLoggedIn, setRedirect } = useCustomAuth();
    const attrs = useAttrs();

    async function onSignIn() {
        setRedirect(route.fullPath);
        await navigateTo('/sign-in');
    }
</script>

<style lang="scss" scoped></style>
